// Unified trade taxonomy for the whole app.
// SINGLE SOURCE OF TRUTH = Control Center Tag Manager (backend skill_tags), served at
// GET /api/verticals. The static list below is only a first-paint fallback + it powers
// the synchronous /sales-jobs routing dispatcher. Everything visible (pill rows) should
// use the live `useVerticals()` hook so owner add/move/remove propagates instantly.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Curated aliases (stable indexed SEO URLs), mirror of backend curated VERTICALS.
export const VERTICALS = [
  { slug: "roofing", label: "Roofing" },
  { slug: "solar", label: "Solar" },
  { slug: "windows", label: "Windows" },
  { slug: "siding", label: "Siding" },
  { slug: "hvac", label: "HVAC" },
  { slug: "remodeling", label: "Home Remodeling" },
  { slug: "bathroom-remodeling", label: "Bathroom Remodeling" },
  { slug: "pest-control", label: "Pest Control" },
  { slug: "home-security", label: "Home Security" },
  { slug: "flooring", label: "Flooring" },
  { slug: "gutters", label: "Gutters" },
  { slug: "fencing", label: "Fencing" },
  { slug: "concrete-foundation", label: "Concrete & Foundation" },
  { slug: "landscaping", label: "Landscaping & Lawn Care" },
  { slug: "water-treatment", label: "Water Treatment" },
  { slug: "pool-spa", label: "Pool & Spa" },
];

export const VERTICAL_SLUGS = new Set(VERTICALS.map((v) => v.slug));

// The 50 US state hub slugs (finite + stable). Used by the routing dispatcher so that
// any non-city, non-state slug is treated as a TRADE vertical hub (present or future).
const STATE_NAMES = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
  "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
  "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan",
  "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
  "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
  "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
  "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
  "Wisconsin", "Wyoming", "District of Columbia",
];
export const STATE_SLUGS = new Set(STATE_NAMES.map((s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-")));

// Module-level cache so the list is fetched once per session.
let _cache = null;
let _inflight = null;

export function useVerticals() {
  const [verticals, setVerticals] = useState(_cache || VERTICALS);
  useEffect(() => {
    if (_cache) { setVerticals(_cache); return; }
    if (!_inflight) _inflight = api.get("/verticals").then((r) => { _cache = r.data || VERTICALS; return _cache; }).catch(() => VERTICALS);
    let alive = true;
    _inflight.then((list) => { if (alive) setVerticals(list); });
    return () => { alive = false; };
  }, []);
  return verticals;
}
